import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";
import { baseText } from "../../Lang/fa/BaseText";
import { Lang } from "../../Lang/MainLang";
import arrow_search from '../../assets/SMSVG/arrow-search.svg'

const ListStyle = styled.div`
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  color: var(--text-2);
  height: calc(100% - 5rem);
  padding-bottom: 5rem;
  background-color: var(--body-2);
  
  .close {
    position: relative;
    width:calc( 100% - 2rem);
    padding: 1rem;
    fill: var(--primary-1);
    display: flex;
    flex-direction: row;
    align-items: center;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 1rem;
    .lux{
        font-size: 1.4rem;
        font-weight: 700;
        color: var(--primary-5);
        margin-right: 0.8rem;
    }
  }

  .subs {
    display: none;
    &.active-sub {
      display: flex;
      flex-direction: column;
    }
  }
  .item {
    cursor: pointer;
    text-decoration: none;
    color: inherit;
  }
  .out-menu {
    text-decoration: none;
    .data-main-1 .name{
        padding:0.8rem var(--padding);
        font-size: 0.87rem;
        color: #111111;
        cursor: pointer;
        font-weight: 500;
        }
    }
  
  .item-1 {
    display: flex;
    flex-direction: column;
    .data-main-1 {
        padding: 0 1rem;
        display: flex;
    }  
    .icon {
      display: flex;
      font-size: 1.3rem;
      margin: 0 1rem;
      color: var(--text-9);
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 1.125em;
      }
    }
    .arrow-base {
        width: 14px;
        height: 14px;
        fill: #484849;
        &.top {
            transform: rotate(90deg);
        }
        &.down {
            transform: rotate(-90deg);
        }
    }
    .main-arrow {
        width: 14px;
        height: 14px;
        fill: #484849;
    }
    .name {
        display: flex;
        padding: 0.8rem 0;
        color: var(--text-9);
        font-weight: 500;
        font-size: 1rem;
    }
    .groups {
        display: none;
        flex-direction: column;
        &.active {
            border-bottom: 1px solid var(--gray-6);
            display: flex;
        }
        .tags {
            display: none;
            flex-direction: column;
            &.active-tag {
                display: flex;
                align-items: flex-start;
                background: var(--light-bg2);
                padding: 0 1rem;

            }
        }
    }
    .item-2 {
        display: flex;
        flex-direction: column;
        :last-child{
            margin-bottom: 1rem;
        }
        .data-main-2 {
            display: flex;
            justify-content: space-between;
            .name{
                padding: 0.8rem 1rem;
                font-size: 0.87rem;
                font-weight: 800;
            }
        }
        &.active {
            margin-bottom: 1rem;
            .data-main-2 .name{
                color: var(--primary-5);
            }
        }
        .item{
            padding-right: 4px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            .name{
                font-size: 0.87rem;
            }
        }
        .item-3 {
            display: flex;
            flex-direction: column;
            .data-main-3 {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                .name{
                    text-decoration: none;
                }
            }
            .circle {
                width: 4px;
                height: 4px;
                background: var(--gray-6);
                flex: none;
                border-radius:var(--border-radius-7);
                margin-left: 0.5rem;
            }
            .item-4 {
                display: flex;
                padding: 0 1rem;
                flex-direction: row;
                align-items: center;  
            }
        }
    }
  }
`;

export const UniDrawerList = (props) => {
    const [openGoods, setOpenGoods] = useState(true);
    const [openGroup, setOpenGroup] = useState(-1);
    const [openTag, setOpenTag] = useState(-1);
    

    useEffect(()=> {
        if(props.location.pathname && props.menus){
            if(props.location.pathname.split('/')[1] === 'category'){
                setOpenGoods(true);
                let findGr = props.menus.findIndex((value) => value.G_GR_EN_NAME === props.location.pathname.split('/')[2])
                if(findGr !== -1){
                    setOpenGroup(findGr)
                } else {
                    props.menus.forEach((value1, i1) => {
                        value1.TAG.forEach((value2, i2) => {
                            let findTag3 = value2.SUB_GROUP.findIndex((value3) => value3.G_SUBGR_EN_NAME === props.location.pathname.split('/')[2])
                            if(findTag3 !== -1){
                                setOpenGroup(i1)
                                setOpenTag(i2)
                            }
                        })
                    })
                }
            }
        }
    }, [props.location.pathname, props.menus])

    const openGroupClick = (index) => {
        if(openGroup === index) {
            setOpenGroup(-1)
        } else {
            setOpenGroup(index)
        }
    }

    const arrow = (name, dir = 'down', num = 1) => {
        // return <svg className={"arrow-base " + name + "-arrow-" + num + ((dir) ? " " + dir : "")} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 150 150"><title>arrows-footer</title><path className="st0" d="M37.5,8.1c0,1.9,0.8,3.7,2.2,5.1l55.2,52.1c4.7,4.4,4.9,11.8,0.5,16.4l-52.1,55.2c-2.8,2.7-2.9,7.1-0.2,9.9 c2.7,2.8,7.1,2.9,9.9,0.2c0.2-0.1,0.3-0.3,0.4-0.5l52.1-55.2c4.7-4.9,7.2-11.5,7-18.3c-0.2-6.8-3.1-13.2-8-17.9L49.3,3 c-2.8-2.6-7.2-2.5-9.9,0.3C38.2,4.6,37.5,6.3,37.5,8.1z"></path></svg>
        return (
            <svg className={"arrow-base " + name + "-arrow-" + num + ((dir) ? " " + dir : "")} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12L14 6V18L8 12Z" fill="#03053D"/>
            </svg>
        )
    }

    // make subgroup list
    const makeSubGroups = (subs, G_GR_CODE) => {
        let newsubs = []
        newsubs = subs.map((value, index) => {
            return (
            <NavLink
                key={index}
                to={"/category/" + value.G_SUBGR_EN_NAME+'/'}
                className="sub item item-4"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="circle"></div>
                <div className="name">{value.G_SUBGR_NAME}</div>
            </NavLink>
            )
        });
        return newsubs
    }

    const makeTags = (tags,G_GR_EN_NAME) => {
        let newtags = [];
        newtags = tags.map((value, index) => {
            let active = false
            if(openTag === index){
                active = true
            }
            return (
                <div
                    key={index}
                    
                    className={"item tag item-3" + ((active) ? ' active' : '')}
                >
                    <div className="data-main-3" >
                        <Link to={"/category/" + value.G_TAG_EN_NAME+'/'} className="name" onClick={() => props.toggleDrawer(false)}>{value.G_TAG_NAME}</Link>
                    </div>
                    <div className={"subs active-sub "}>
                        {makeSubGroups(value.SUB_GROUP, value.G_TAG_EN_NAME)}
                    </div>
                </div>
            )
        })
        newtags.splice(0, 0, (
            <Link
            key={-1}
            to={"/category/" + G_GR_EN_NAME}
            className={"item" + ((props.location.pathname === "/category/" + G_GR_EN_NAME) ? ' active' : '')}
            onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main">
                    <div className="name" >{baseText.all}</div>
                </div>

            </Link>
        ))
    return newtags
    }

    // make groups list
    const makeGroups = () => {
        return props.menus.map((value, index) => {
            // let path = "/category/" + value.G_GR_CODE;
            // let pathL = props.location.pathname.split('/')
            // pathL.splice(3, pathL.length - 3);
            // pathL = pathL.join('/');
            // if(pathL === path){
            //     active = true
            // }
            // if(openGroup !== -1){
            //     active = false
            //     if(openGroup === index){
            //     active=true
            //     }
            // }
            let active = false
            if(openGroup === index){
                active = true
            }
            return (
                <React.Fragment key={index}>
                    <div
                        key={index}
                        // to={"/category/" + value.G_GR_CODE}
                        className={"item group item-2" + ((active) ? ' active' : '')}
                    >
                        <div className="data-main-2" onClick={() => openGroupClick(index)}>
                            <div className="name">{value.G_GR_NAME}</div>
                            <div className="icon">
                                {arrow('group', ((active) ? 'top' : 'down'), 2)}
                            </div>
                        </div>
                        <div className={"tags" + ((active) ? ' active-tag': '')}>
                            {makeTags(value.TAG,value.G_GR_EN_NAME)}
                        </div> 
                    </div>
                </React.Fragment>
            )
        })
    }

    return (
        <ListStyle className={(props.home ? "padd" : '')}>
            <>
                <div className="close" >
                    <img src={arrow_search} alt='close' onClick={() => props.toggleDrawer(false)}/>
                    <span className="lux">لوکسین لوکس</span>
                </div>
                <div className="padd"></div>
            </>
            <div
                className={"item item-1 active"}
            >
                <div className="data-main-1" >
                <div className="name">{baseText.allCategories}</div>
                </div>
                <div className={"groups" + ((openGoods) ? " active" : "")}>
                    {makeGroups()}
                </div>
            </div>
            <NavLink
                to="/shops"
                className=" out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.shops}</div>
                </div>
            </NavLink>
            <NavLink
                to="/brands/"
                className=" out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.brands}</div>
                </div>
            </NavLink>
            
            <NavLink
                to="/singup-seller"
                className=" out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.shopRequest}</div>
                </div>
            </NavLink>
        
            <NavLink
                to="/aboutus"
                className="out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.aboutUs}</div>
                </div>
            </NavLink>
            <NavLink
                to="/contactus"
                className="out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.contactUs}</div>
                </div>
            </NavLink>
            <NavLink
                to="/rules"
                className=" out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.rules}</div>
                </div>
            </NavLink>
            <NavLink
                to="/application"
                className=" out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.app}</div>
                </div>
            </NavLink>
            <NavLink
                to="/campaign/discover-luxury/"
                className=" out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.discover_luxury}</div>
                </div>
            </NavLink>
            <NavLink
                to="/campaign/luxgardi/"
                className=" out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.luxgardi}</div>
                </div>
            </NavLink>
            <a
               href={process.env.REACT_APP_MAIN + "/blog/"}
                className=" disable out-menu"
                onClick={() => props.toggleDrawer(false)}
            >
                <div className="data-main-1" onClick={() => setOpenGoods(!openGoods)}>
                <div className="name">{Lang.Footer.blog}</div>
                </div>
            </a>
        </ListStyle>
    );
}
